import { render, staticRenderFns } from "./AutocompleteResults.vue?vue&type=template&id=84b2f0dc&scoped=true"
import script from "./AutocompleteResults.vue?vue&type=script&lang=js"
export * from "./AutocompleteResults.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteResults.vue?vue&type=style&index=0&id=84b2f0dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b2f0dc",
  null
  
)

export default component.exports